import { render, staticRenderFns } from "./editProject.vue?vue&type=template&id=8fb8f46c&"
import script from "./editProject.vue?vue&type=script&lang=js&"
export * from "./editProject.vue?vue&type=script&lang=js&"
import style0 from "./editProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports